// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2-d_h","bigColWidth":"Table_bigColWidth__3ca_R","biggerColWidth":"Table_biggerColWidth__1Imyc","row":"Table_row__3BPGF","col":"Table_col__3Gzwx"};